import React, {useState} from "react";
import "./profile.css";
import useUserContext from "../../hooks/useUserContext";
import {BigInput} from "../../components/forms/bigInput/BigInput";

const Profile = () => {
    const { user } = useUserContext();
    if(!user) return null;

    return (
        <div className="profile-container">
            <div className="title">
                Your Profile
            </div>
            <div className="section">
                <div className="field">
                    <div className="label">Name: <span>{user.name}</span></div>
                </div><div className="field">
                    <div className="label">Email: <span>{user.email}</span></div>
                </div><div className="field">
                    <div className="label">Domains: <span className="domains">{user.shopDomains.map(domain => <div key={`domain-item-${domain}`} className="domain">{domain}</div>)}</span></div>
                </div>
            </div>
        </div>
    );
}

export default Profile;